import React from 'react';
import PropTypes from 'prop-types';
import { FilterStoreProvider } from './searchFilterPanel/FilterStoreProvider';
import SearchContent from './SearchContent';

/**
 * Search Page Wrapper
 * This component provides the FilterStore to the SearchContent.
 */
export default function Search({ hostname }) {
  return (
    <FilterStoreProvider initialFilters={{}}>
      <SearchContent hostname={hostname} />
    </FilterStoreProvider>
  );
}

Search.propTypes = {
  hostname: PropTypes.string.isRequired,
};